// app
const WEB_APP_ID = 'admin'
const WEB_APP_SERVICE = 'admin-service'
const CHATBOT_SERVICE = 'chat-bot-api'

// grids
const OBJECT_TYPES_GRID_ID = 'object_types_grid'
const OBJECT_TYPE_GROUPS_GRID_ID = 'object_type_groups_grid'
const TYPE_GROUP_OBJECT_TYPES_GRID_ID = 'type_group_object_types_grid'
const COLLECTION_TYPES_GRID_ID = 'collection_types_grid'
const DATA_SET_TYPES_GRID_ID = 'data_set_types_grid'
const VOCABULARY_TYPES_GRID_ID = 'vocabulary_types_grid'
const PROPERTY_TYPES_GRID_ID = 'property_types_grid'
const USERS_GRID_ID = 'users_grid'
const USERS_OF_GROUP_GRID_ID = 'users_of_group_grid'
const GROUPS_GRID_ID = 'groups_grid'
const GROUPS_OF_USER_GRID_ID = 'groups_of_user_grid'
const ROLES_OF_USER_GRID_ID = 'roles_of_user_grid'
const ROLES_OF_USERS_GRID_ID = 'roles_of_users_grid'
const ROLES_OF_GROUP_GRID_ID = 'roles_of_group_grid'
const ROLES_OF_GROUPS_GRID_ID = 'roles_of_groups_grid'
const VOCABULARY_TERMS_GRID_ID = 'vocabulary_terms_grid'
const DYNAMIC_PROPERTY_PLUGINS_GRID_ID = 'dynamic_property_plugins_grid'
const ENTITY_VALIDATION_PLUGINS_GRID_ID = 'entity_validation_plugins_grid'
const QUERIES_GRID_ID = 'queries_grid'
const QUERY_RESULTS_GRID_ID = 'query_results_grid'
const HISTORY_OF_DELETION_GRID_ID = 'history_of_deletion_grid'
const HISTORY_OF_FREEZING_GRID_ID = 'history_of_freezing_grid'
const PERSONAL_ACCESS_TOKEN_GRID_ID = 'personal_access_token_grid'
const TRASHCAN_GRID_ID = 'trashcan_grid'

// browsers
const DATABASE_BROWSER_ID = 'database_browser'
const TYPE_BROWSER_ID = 'type_browser'
const USER_BROWSER_ID = 'user_browser'
const TOOL_BROWSER_ID = 'tool_browser'

// form
const ENTITY_TYPE_FORM_ID = 'entity_type_form'
const OBJECT_TYPE_GROUP_FORM_ID = 'object_type_group_form'
const VOCABULARY_TYPE_FORM_ID = 'vocabulary_type_form'
const USER_FORM_ID = 'user_form'
const USER_GROUP_FORM_ID = 'user_group_form'
const PLUGIN_FORM_ID = 'plugin_form'
const QUERY_FORM_ID = 'query_form'
const IMPORT_ALL_FORM_ID = 'import_all_form'
const PERSONAL_ACCESS_TOKEN_FORM_ID = 'personal_access_token_form'
const TRASHCAN_FORM_ID = 'trashcan_form'

export default {
  // app
  WEB_APP_ID,

  // service,
  WEB_APP_SERVICE,
  CHATBOT_SERVICE,
  
  // grids
  OBJECT_TYPES_GRID_ID,
  OBJECT_TYPE_GROUPS_GRID_ID,
  TYPE_GROUP_OBJECT_TYPES_GRID_ID,
  COLLECTION_TYPES_GRID_ID,
  DATA_SET_TYPES_GRID_ID,
  VOCABULARY_TYPES_GRID_ID,
  PROPERTY_TYPES_GRID_ID,
  USERS_GRID_ID,
  USERS_OF_GROUP_GRID_ID,
  GROUPS_GRID_ID,
  GROUPS_OF_USER_GRID_ID,
  ROLES_OF_USER_GRID_ID,
  ROLES_OF_USERS_GRID_ID,
  ROLES_OF_GROUP_GRID_ID,
  ROLES_OF_GROUPS_GRID_ID,
  VOCABULARY_TERMS_GRID_ID,
  DYNAMIC_PROPERTY_PLUGINS_GRID_ID,
  ENTITY_VALIDATION_PLUGINS_GRID_ID,
  QUERIES_GRID_ID,
  QUERY_RESULTS_GRID_ID,
  HISTORY_OF_DELETION_GRID_ID,
  HISTORY_OF_FREEZING_GRID_ID,
  PERSONAL_ACCESS_TOKEN_GRID_ID,
  TRASHCAN_GRID_ID,

  // browsers
  DATABASE_BROWSER_ID,
  TYPE_BROWSER_ID,
  USER_BROWSER_ID,
  TOOL_BROWSER_ID,

  // forms
  ENTITY_TYPE_FORM_ID,
  OBJECT_TYPE_GROUP_FORM_ID,
  VOCABULARY_TYPE_FORM_ID,
  USER_FORM_ID,
  USER_GROUP_FORM_ID,
  PLUGIN_FORM_ID,
  QUERY_FORM_ID,
  IMPORT_ALL_FORM_ID,
  PERSONAL_ACCESS_TOKEN_FORM_ID,
  TRASHCAN_FORM_ID
}
